// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"60ad8356","9":"37f59e19","203":"11a6a7b2","277":"ff146534","298":"0de21c1e","316":"713392e9","369":"56b90b0b","478":"d4194c7c","569":"78a7cce2","616":"b24eee2a","648":"fd1bdb8d","666":"e8b0cee8","871":"ba03b3d1","951":"4b9d59a4","971":"777362d3","989":"18a04596"}[chunkId] + ".chunk.js";
};